import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { useEffect } from 'react';

/**
 * Инициализация Sentry для мониторинга ошибок и производительности
 * Включает интеграции с React Router и Session Replay
 */
export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const isDevelopment = import.meta.env.MODE === 'development';

  // Пропускаем инициализацию если DSN не указан
  if (!dsn) {
    console.warn('Sentry DSN не указан, мониторинг ошибок отключен');
    return;
  }

  Sentry.init({
    dsn,
    environment: isDevelopment ? 'development' : 'production',
    integrations: [
      // Интеграция с React Router для отслеживания навигации
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      // Воспроизведение сессий пользователей
      Sentry.replayIntegration({
        maskAllText: true, // Скрываем текст для соответствия GDPR
        blockAllMedia: true, // Блокируем медиа контент
      }),
    ],
    // Процент транзакций для отслеживания производительности
    tracesSampleRate: isDevelopment ? 0 : 0.1,
    // Процент сессий для записи реплеев
    replaysSessionSampleRate: isDevelopment ? 0 : 0.1,
    // Записываем 100% сессий с ошибками
    replaysOnErrorSampleRate: 1.0,
    // Фильтруем ошибки в режиме разработки
    beforeSend(event) {
      if (isDevelopment) {
        console.warn('[Sentry]', event);
        return null;
      }
      return event;
    },
    // Включаем source maps для production
    enabled: !isDevelopment,
  });
};
